import { axiosPost, axiosPut } from "../../RestApis/restApiUseAxios";
import axiosInstance from "../axios/axios";

const getCatogeryById = async (categoryId) => {
  try {
    const response = await axiosInstance.get(
      `/Category/getCategoryDetailsByCategoryId/${categoryId}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching getCatogeryById:", error);
  }
};

const addSupplierCommissionSummary = async (userId, companyId, body) => {
  try {
    const response = await axiosInstance.post(
      `/Commision/addSupplierCommissionSummary/${userId}/${companyId}`,
      body,
      {
        timeout: 100000,
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching addSupplierCommissionSummary:", error);
  }
};

const getSupplierCommisionSummary = async (userId, companyId) => {
  try {
    const response = await axiosInstance.get(
      `/Commision/getSupplierCommisionSummary/${userId}/${companyId}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching getSupplierCommisionSummary:", error);
  }
};

const getSupplierCommisionData = async (
  userId,
  companyId,
  commisionReportId
) => {
  try {
    const response = await axiosInstance.get(
      `/Commision/getSupplierCommisionData/${userId}/${companyId}/${commisionReportId}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching getSupplierCommisionData:", error);
  }
};

const updateSupplierCommisionDetails = async (
  commisionReportId,
  sourceTypeId
) => {
  try {
    const response = await axiosPut(
      `/contract/update-supplier-commision-details`,
      { CommisionReportId: commisionReportId, SourceTypeId: sourceTypeId }
    );
    return response;
  } catch (error) {
    console.error("Error fetching updateSupplierCommisionDetails:", error);
  }
};

const getSupplierCommisionDetails = async (
  userId,
  companyId,
  commisionReportId
) => {
  try {
    const response = await axiosInstance.get(
      `/Commision/getSupplierCommissionDetails/${userId}/${companyId}/${commisionReportId}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching getSupplierCommisionDetails:", error);
  }
};

const deleteReportCommisionSummary = async (commisionReportId) => {
  try {
    const response = await axiosPut(`/contract/delete-report-summary`, {
      CommisionReportId: commisionReportId,
    });
    return response;
  } catch (error) {
    console.error("Error fetching deleteReportCommisionSummary:", error);
  }
};

export const CommisionService = {
  getCatogeryById,
  addSupplierCommissionSummary,
  getSupplierCommisionSummary,
  getSupplierCommisionData,
  updateSupplierCommisionDetails,
  getSupplierCommisionDetails,
  deleteReportCommisionSummary,
};
